import { Controller } from "stimulus"

// Opens a URL in a new tab as soon as this controller connects — used on Donation Flow's
// thank-you page to also open the client's own real thank-you page alongside ours.
// Note: since the click that led here happened on the *previous* page (the donation form
// submit), this isn't a direct user gesture on THIS page — most browsers still allow a
// window.open() that fires immediately on load right after a real navigation, but a popup
// blocker could still block it in some browsers/settings.
export default class extends Controller {
  static values = { url: String }

  connect() {
    if (this.urlValue) window.open(this.urlValue, "_blank", "noopener")
  }
}
